import { render, staticRenderFns } from "./NodeDescription.vue?vue&type=template&id=24c71c90"
import script from "./NodeDescription.vue?vue&type=script&lang=ts"
export * from "./NodeDescription.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports